import { Badge } from "@material-ui/core";
import { Search, ShoppingCartOutlined } from "@material-ui/icons";
import React from "react";
import styled from "styled-components";
import { mobile } from "../responsiveM";
import { tablet } from "../responsiveT";
import { Link } from "react-router-dom";

const Container = styled.div`
  height: 60px;
  ${mobile({ height: "50px" })}
  ${tablet({ padding: "10px 0" })}
`;

const Wrapper = styled.div`
  padding: 10px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  ${mobile({ padding: "10px 0px" })}
`;

const Left = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
`;

const Language = styled.span`
  font-size: 14px;
  cursor: pointer;
  ${mobile({ display: "none" })}
`;

const SearchContainer = styled.div`
  border: 0.5px solid lightgray;
  display: flex;
  align-items: center;
  margin-left: 25px;
  padding: 5px;
  ${mobile({ marginLeft: "15px" })}
`;

const Input = styled.input`
  border: none;
  ${mobile({ width: "35px", fontSize: "10px" })}
  ${tablet({ width: "80px", fontSize: "15px" })}
`;

const Center = styled.div`
  flex: 1;
  text-align: center;
`;

const Logo = styled.h1`
  font-weight: bold;
  ${mobile({ fontSize: "15px" })}
  ${tablet({ fontSize: "25px" })}
`;

const Right = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  ${mobile({ flex: 1.2, justifyContent: "center" })}
`;

const MenuItem = styled.div`
  font-size: 14px;
  cursor: pointer;
  margin-left: 25px;
  ${mobile({ fontSize: "8px", marginLeft: "5px" })}
  ${tablet({ fontSize: "14px", marginLeft: "10px", fontWeight: "bold" })}
`;

const BadgeContainer = styled.div`
  ${mobile({ display: "none" })}
`;


const Navbar = () => {
  return (
    <Container>
      <Wrapper>
        <Left>
          <Language>EN</Language>
          <SearchContainer>
            <Input placeholder="Search" />
            <Search style={{ color: "gray", fontSize: 14 }} />
          </SearchContainer>
        </Left>
        <Center>
          <Logo>JEWEL FASHION</Logo>
        </Center>
        <Right>
          <MenuItem><Link className="link" to="/">HOME</Link></MenuItem>
          <MenuItem><Link className="link" to="/product">PRODUCTS</Link></MenuItem>
          <MenuItem><Link className="link" to="/login">SIGN IN</Link></MenuItem>
          <MenuItem >
            <Link className="link" to="/cart">
              <BadgeContainer>
                <Badge badgeContent={3} color="primary">
                <ShoppingCartOutlined />
                </Badge>
              </BadgeContainer>
            </Link>
          </MenuItem>
        </Right>
      </Wrapper>
    </Container>
  );
};

export default Navbar;
